import { axiosInstance } from '@configs/axios/axiosInstance';

import type { GetInstructorsUnapprovedResult } from './getInstructorsUnapproved.types';

/**
 * Fetch instructors pending approval, grouped by discipline.
 * Endpoint: GET /instructors/unapproved
 *
 * `customerId` is sent as a request header.
 * Returns counts per discipline (groundschool, simulator, simcheck)
 * and a total instructorCount across all disciplines.
 */
export async function getInstructorsUnapproved(
  customerId: string
): Promise<GetInstructorsUnapprovedResult> {
  const response = await axiosInstance.get<GetInstructorsUnapprovedResult>(
    '/instructors/unapproved',
    { headers: { 'X-Customer-Id': customerId } }
  );

  return response.data;
}
